import { useState } from 'react';

import { StaticImage } from '@/common/constants/displateRoutes';
import { noImageUrl } from '@/modules/Lumino/LuminoPage/constants';

import styles from './sliderArtworkItem.module.scss';

interface SliderImageProps {
  src: string;
  srcSet?: string;
  alt?: string;
  className?: string;
  onError?: (() => void) | null;
  afterLoad?: () => void;
  width?: number;
  height?: number;
}

export const SliderLazyImage = ({
  src,
  srcSet,
  alt = '',
  className = '',

  onError = null,
  afterLoad,

  width,
  height,
}: SliderImageProps): JSX.Element => {
  const [showFallback, setShowFallback] = useState(false);

  const handleError = (): void => {
    setShowFallback(true);
    onError && onError();
  };

  const handleAfterLoad = (): void => {
    afterLoad && afterLoad();
  };

  return (
    <>
      {showFallback ? (
        <img
          alt="no-image"
          className={styles.fallbackImage}
          height={height}
          src={StaticImage(noImageUrl)}
          width={width}
        />
      ) : (
        <img
          alt={alt}
          className={className}
          draggable={false}
          height={height}
          loading="lazy"
          onError={handleError}
          onLoad={handleAfterLoad}
          src={src}
          srcSet={srcSet}
          width={width}
        />
      )}
    </>
  );
};
